(function () {
  // Skip on product templates that don't use subscriptions
  const templateEl = document.querySelector('[data-template]');
  if (templateEl && templateEl.dataset.template === 'product.smart-band') return;
  const observer = new MutationObserver(() => {
    // Inject subscribe perks (re-injects if Appstle re-renders after variant change)
    const subscribeOption = document.querySelector(
      "#appstle_subscription_widget0 .appstle_include_dropdown",
    );
    if (
      subscribeOption &&
      !subscribeOption.querySelector(".custom-subscribe-perks")
    ) {
      const perksHTML = `
        <ul class="custom-subscribe-perks">
          <li>Pause or cancel anytime</li>
          <li>15% off recurring orders</li>
          <li>Free shipping on all orders</li>
        </ul>
      `;
      subscribeOption.insertAdjacentHTML("beforeend", perksHTML);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Remove any leftover custom qty pickers from previous versions
  document.querySelectorAll('.custom-qty-picker').forEach(el => el.remove());

  // Price sync — runs independently from perks injection
  let currentUnitPrice = 0;
  let currentCurrencySymbol = "";
  let currentQuantity = 1;
  let priceSyncReady = false;
  const priceSyncObserver = new MutationObserver(() => {
    if (priceSyncReady) return;
    const widget = document.querySelector("#appstle_subscription_widget0");
    const activeOption =
      widget &&
      widget.querySelector(
        ".appstle_subscription_wrapper_option.appstle-active-option",
      );
    if (!widget || !activeOption) return;

    priceSyncReady = true;
    priceSyncObserver.disconnect();
    setupPriceSync(widget);
  });
  priceSyncObserver.observe(document.body, { childList: true, subtree: true });

  // Parse a price string into a number
  function parsePrice(text) {
    // Extract currency symbol
    const symbolMatch = text.match(/^([^\d\s.,]+)|([^\d\s.,]+)$/);
    const symbol = symbolMatch ? symbolMatch[1] || symbolMatch[2] : "";
    // Remove currency symbol and spaces
    let numStr = text.replace(symbol, "").trim();
    // Handle European format:
    if (numStr.includes(",")) {
      numStr = numStr.replace(/\./g, "").replace(",", ".");
    }
    return { value: parseFloat(numStr), symbol: symbol };
  }

  // Format a number back to the original currency format
  function formatPrice(value, symbol) {
    // Format as European style with comma decimal: 27,19
    const parts = value.toFixed(2).split(".");
    // Add thousand separator dots
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return symbol + parts.join(",");
  }

  function updateDisplayedPrice() {
    const priceContainer = document.querySelector(
      'product-price [ref="priceContainer"]',
    );
    if (!priceContainer || !currentUnitPrice) return;

    const priceEl = priceContainer.querySelector(".price");
    if (priceEl) {
      const total = currentUnitPrice * currentQuantity;
      priceEl.textContent = formatPrice(total, currentCurrencySymbol);
    }
  }

  function updateWidgetPriceOverlay() {
    if (!currentUnitPrice) return;
    const widget = document.querySelector("#appstle_subscription_widget0");
    if (!widget) return;
    const priceWrapper = widget.querySelector(".appstle_one_time_price_wrapper");
    if (!priceWrapper) return;

    const total = currentUnitPrice * currentQuantity;
    const formatted = formatPrice(total, currentCurrencySymbol);

    // Hide all Appstle content, show our overlay
    priceWrapper.style.position = "relative";
    priceWrapper.style.visibility = "hidden";

    let overlay = priceWrapper.querySelector(".custom-price-overlay");
    if (!overlay) {
      overlay = document.createElement("span");
      overlay.className = "custom-price-overlay";
      overlay.style.cssText =
        "position:absolute;inset:0;display:flex;align-items:center;justify-content:flex-end;visibility:visible;";
      priceWrapper.appendChild(overlay);
    }
    overlay.textContent = formatted;
  }

  function syncPriceFromWidget(widget) {
    const activeOption = widget.querySelector(
      ".appstle_subscription_wrapper_option.appstle-active-option",
    );
    if (!activeOption) return;

    // Get the price from the active option — try subscription amount first, then one-time
    let priceText = "";
    const subscriptionAmount = activeOption.querySelector(
      ".appstle_subscription_amount",
    );
    const oneTimePriceWrapper = activeOption.querySelector(
      ".appstle_one_time_price_wrapper",
    );

    if (subscriptionAmount) {
      priceText = subscriptionAmount.textContent.trim();
    } else if (oneTimePriceWrapper) {
      const priceSpan =
        oneTimePriceWrapper.querySelector(".transcy-money") ||
        oneTimePriceWrapper;
      priceText = priceSpan.textContent.trim();
    }

    if (!priceText) return;

    // Parse and store the unit price
    const parsed = parsePrice(priceText);
    currentUnitPrice = parsed.value;
    currentCurrencySymbol = parsed.symbol;

    // Sync quantity based on active option
    const isOneTime =
      !!oneTimePriceWrapper &&
      activeOption.querySelector(".appstle_one_time_details_wrapper");
    const mainQtyInput = document.querySelector('input[name="quantity"]');
    if (!isOneTime) {
      // Subscription: always quantity 1
      currentQuantity = 1;
      if (mainQtyInput) {
        mainQtyInput.value = "1";
        mainQtyInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    } else {
      // One-time: variant price already includes the quantity (e.g. "6" variant = $236.99)
      // so we don't multiply again
      currentQuantity = 1;
      if (mainQtyInput) {
        mainQtyInput.value = "1";
        mainQtyInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    // Update the displayed price (unit × quantity)
    updateDisplayedPrice();

    // Hide compare-at price
    const priceContainer = document.querySelector(
      'product-price [ref="priceContainer"]',
    );
    if (!priceContainer) return;
    const compareEl = priceContainer.querySelector(".compare-at-price");
    if (compareEl) {
      const parentGroup = compareEl.closest('[role="group"]');
      if (parentGroup) parentGroup.style.display = "none";
    }
  }

  function setupPriceSync(widget) {
    // Watch for any DOM/attribute changes inside the widget
    const priceObserver = new MutationObserver(() => {
      syncPriceFromWidget(widget);
    });

    priceObserver.observe(widget, {
      attributes: true,
      attributeFilter: ["class"],
      subtree: true,
      childList: true,
    });

    // Click listener for immediate feedback
    widget.addEventListener("click", () => {
      setTimeout(() => syncPriceFromWidget(widget), 100);
    });

    // Listen for variant picker changes (amount select)
    const variantPicker = document.querySelector("variant-picker");
    if (variantPicker) {
      variantPicker.addEventListener("change", () => {
        setTimeout(() => syncPriceFromWidget(widget), 200);
      });
    }

    // Initial sync
    syncPriceFromWidget(widget);
  }
})();
